import React from "react";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_boarding-school-fit/artifacts/5kmsljm9_ESA%20Final%20Logo.png";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-[#FDFCF8]">
      {/* Header */}
      <header className="bg-[#FDFCF8] border-b border-[#E2E8F0] py-4">
        <div className="container mx-auto px-4 md:px-8 max-w-7xl flex items-center justify-between">
          <Link to="/">
            <img src={LOGO_URL} alt="Elite School Advisory" className="h-12 w-auto" />
          </Link>
          <Link
            to="/"
            className="flex items-center gap-2 text-[#2B4C7E] hover:text-[#C9A227] transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="container mx-auto px-4 md:px-8 max-w-4xl py-16">
        <h1
          className="text-3xl md:text-4xl font-semibold text-[#1A202C] mb-8"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Privacy Policy
        </h1>

        <div className="prose prose-lg max-w-none text-[#4A5568]">
          <p className="text-sm text-[#4A5568] mb-8">
            Last updated: December 2025
          </p>

          <section className="mb-8">
            <h2 className="text-xl font-medium text-[#1A202C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              1. Introduction
            </h2>
            <p>
              Elite School Advisory ("we", "our", "us"), operated by Mindways Consulting Pvt Ltd, New Delhi, is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-medium text-[#1A202C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              2. Information We Collect
            </h2>
            <p className="mb-4">We collect information that you provide directly to us, including:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Name and contact information (email, phone number)</li>
              <li>Child's educational information (current grade, school preferences)</li>
              <li>Preferred destinations and timeline for admissions</li>
              <li>Any other information you choose to provide during consultations</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-medium text-[#1A202C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              3. How We Use Your Information
            </h2>
            <p className="mb-4">We use the information we collect to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Provide, maintain, and improve our advisory services</li>
              <li>Respond to your enquiries and schedule consultations</li>
              <li>Send you relevant information about schools and admissions</li>
              <li>Communicate with you about our services</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-medium text-[#1A202C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              4. Information Sharing
            </h2>
            <p>
              We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as necessary to provide our services (e.g., sharing relevant information with schools you are applying to, with your explicit permission) or as required by law.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-medium text-[#1A202C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              5. Data Security
            </h2>
            <p>
              We implement appropriate technical and organisational measures to protect your personal information against unauthorised access, alteration, disclosure, or destruction.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-medium text-[#1A202C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              6. Your Rights
            </h2>
            <p className="mb-4">You have the right to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Access the personal information we hold about you</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your information</li>
              <li>Withdraw consent for marketing communications</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-medium text-[#1A202C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              7. Contact Us
            </h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us at:
            </p>
            <p className="mt-4">
              <strong>Elite School Advisory</strong><br />
              Operated by Mindways Consulting Pvt Ltd<br />
              New Delhi, India<br />
              Email: eliteschooladvisory@gmail.com<br />
              Phone: +91 98180 65496
            </p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default PrivacyPolicy;
